import { Component, OnInit } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss', '../../../../assets/sass/style.scss']
})
export class LandingPageComponent implements OnInit {

  rtl: boolean = false;

  constructor( ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/pages/landing-page/landing-page.component.ts